/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Col_Short_ShipmentInputs */

const en_inbound_col_short_shipment = /** @type {(inputs: Inbound_Col_Short_ShipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last shipment`)
};

/**
* | output |
* | --- |
* | "Last shipment" |
*
* @param {Inbound_Col_Short_ShipmentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_col_short_shipment = /** @type {((inputs?: Inbound_Col_Short_ShipmentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Col_Short_ShipmentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_col_short_shipment(inputs)
});